import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export { default as BvWhatsappTemplateParser } from './components/template-parser/BvWhatsappTemplateParser.vue';
export { default as BvWhatsappTemplatePicker } from './components/template-picker/BvWhatsappTemplatePicker.vue';
export { default as BvWhatsappTemplatePreview } from './components/template-preview/BvWhatsappTemplatePreview.vue';

export const whatsappTemplateArray: ComponentType[] = [
  {
    name: 'BvWhatsappTemplate',
    component: defineAsyncComponent(() => import('@bv/components/bbc/whatsapp-template/BvWhatsappTemplate.vue')),
  },
  {
    name: 'BvWhatsappTemplateParser',
    component: defineAsyncComponent(
      () => import('@bv/components/bbc/whatsapp-template/components/template-parser/BvWhatsappTemplateParser.vue'),
    ),
  },
  {
    name: 'BvWhatsappTemplatePicker',
    component: defineAsyncComponent(
      () => import('@bv/components/bbc/whatsapp-template/components/template-picker/BvWhatsappTemplatePicker.vue'),
    ),
  },
  {
    name: 'BvWhatsappTemplatePreview',
    component: defineAsyncComponent(
      () => import('@bv/components/bbc/whatsapp-template/components/template-preview/BvWhatsappTemplatePreview.vue'),
    ),
  },
];

export const whatsappTemplate: Plugin<[]> = toPlugin(whatsappTemplateArray);
